import type { CreateEventStepId } from '../CorporateViewTabs/EventsTab/createEventFormModel';
import type { EventsTourStepId } from './eventsTourSteps';

/**
 * The tour runs outside React, so each host registers the handful of things it
 * alone can do. Everything is optional: a step whose host is not mounted simply
 * skips that behaviour.
 */
export type EventsTourApi = {
  openCreateDialog: () => void;
  closeCreateDialog: () => void;
  setCreateStep: (id: CreateEventStepId) => void;
  openSettings: () => void;
  closeSettings: () => void;
  addRule: () => Promise<void>;
  closeEditor: () => void;
  prepareRuleStep: (id: EventsTourStepId) => void;
};

let api: Partial<EventsTourApi> = {};

export function registerEventsTourApi(
  partial: Partial<EventsTourApi>
): () => void {
  api = { ...api, ...partial };
  return () => {
    for (const key of Object.keys(partial) as (keyof EventsTourApi)[]) {
      if (api[key] === partial[key]) {
        delete api[key];
      }
    }
  };
}

export function getEventsTourApi(): Partial<EventsTourApi> {
  return api;
}
